// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/background/whatwedo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.what-we-do-body {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    width: 100%;
    max-width: 100%;
    height: 120vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #0A012D;
}
.what-we-do-body h1 {
    font-family: "Chakra Petch";
    color: #ffffff;
    font-size: 60px;
    font-weight: 700;
}
.what-we-do-body .container {
    margin-top: 10%;
}
.whatdoswiper-btn{
    position: absolute;
    padding: 5px;
    top:45%;
    z-index: 11;
    width: 100px;
    height: 100px;
    background: linear-gradient(to right, white 0.5px, transparent 1px) 0 0,
    linear-gradient(to right, white 0.5px, transparent 1px) 0 100%,
    linear-gradient(to left, white 0.5px, transparent 1px) 100% 0,
    linear-gradient(to left, white 0.5px, transparent 1px) 100% 100%,
    linear-gradient(to bottom, white 0.5px, transparent 1px) 0 0,
    linear-gradient(to bottom, white 0.5px, transparent 1px) 100% 0,
    linear-gradient(to top, white 0.5px, transparent 1px) 0 100%,
    linear-gradient(to top, white 0.5px, transparent 1px) 100% 100%;
    background-repeat: no-repeat;
    background-size: 6px 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor:pointer;
}
.nextbtn{
    right: 0;
    
}
.backbtn{
    right: 80px;
}
.backicon-border{
    border:1px solid #4A19ED;
    width: 85%;
    height: 85%;
    display: flex;
    align-items: center;
    justify-content: center;
    
}
.backicon-border:hover{
    background-color: #4A19ED;
}
.backicon{
    width: 10px;
}
.doMySwiper .swiper-slide img {
    width: 75%;
}
.what-we-do-body .content-left {
    font-family: "Chakra Petch";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    text-transform: none;
    color: #ffffff;
}
.what-we-do-body .left-area h1 {
    font-size: 20px;
    font-weight: 600;
    color: #ffffff;
    font-family: 'Chakra Petch';
}
.what-we-do-body .left-area .text-area {
    background: #4a19ed;
    padding: 40px 38px;
    width: 540px;
    height: 180px;
}
.what-we-do-body .content-left-border {
    width: -moz-fit-content;
    width: fit-content;
    padding: 6px;
    background: linear-gradient(to right, #4a19ed 0.5px, transparent 2px) 0 0,
      linear-gradient(to right, #4a19ed 0.5px, transparent 2px) 0 100%,
      linear-gradient(to left, #4a19ed 0.5px, transparent 2px) 100% 0,
      linear-gradient(to left, #4a19ed 0.5px, transparent 2px) 100% 100%,
      linear-gradient(to bottom, #4a19ed 0.5px, transparent 2px) 0 0,
      linear-gradient(to bottom, #4a19ed 0.5px, transparent 2px) 100% 0,
      linear-gradient(to top, #4a19ed 0.5px, transparent 2px) 0 100%,
      linear-gradient(to top, #4a19ed 0.5px, transparent 2px) 100% 100%;
    background-repeat: no-repeat;
    background-size: 12px 12px;
    /* ---- */
    position: absolute;
    top: 8%;
    left: 38%;
    transform: translate(40%, 185%);
    z-index: 999999;
}
.what-we-do-body .left-area{
    border: 1px solid #4a19ed;
    width: -moz-fit-content;
    width: fit-content;
    height: max-content;
    padding: 10px;
}
/* .slider-photo {
    width: 300px !important;
}  */
`, "",{"version":3,"sources":["webpack://./src/assets/css/components/whatWe.css"],"names":[],"mappings":"AAAA;IACI,yDAA6D;IAC7D,4BAA4B;IAC5B,sBAAsB;IACtB,2BAA2B;IAC3B,WAAW;IACX,eAAe;IACf,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;AAC7B;AACA;IACI,2BAA2B;IAC3B,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb;;;;;;;mEAO+D;IAC/D,4BAA4B;IAC5B,wBAAwB;IACxB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,QAAQ;;AAEZ;AACA;IACI,WAAW;AACf;AACA;IACI,wBAAwB;IACxB,UAAU;IACV,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;AAE3B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,WAAW;AACf;AACA;IACI,UAAU;AACd;AACA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,2BAA2B;AAC/B;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;AACA;IACI,uBAAkB;IAAlB,kBAAkB;IAClB,YAAY;IACZ;;;;;;;uEAOmE;IACnE,4BAA4B;IAC5B,0BAA0B;IAC1B,SAAS;IACT,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,+BAA+B;IAC/B,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,uBAAkB;IAAlB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;AACjB;AACA;;IAEI","sourcesContent":[".what-we-do-body {\n    background-image: url(\"../../images/background/whatwedo.png\");\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n    width: 100%;\n    max-width: 100%;\n    height: 120vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #0A012D;\n}\n.what-we-do-body h1 {\n    font-family: \"Chakra Petch\";\n    color: #ffffff;\n    font-size: 60px;\n    font-weight: 700;\n}\n.what-we-do-body .container {\n    margin-top: 10%;\n}\n.whatdoswiper-btn{\n    position: absolute;\n    padding: 5px;\n    top:45%;\n    z-index: 11;\n    width: 100px;\n    height: 100px;\n    background: linear-gradient(to right, white 0.5px, transparent 1px) 0 0,\n    linear-gradient(to right, white 0.5px, transparent 1px) 0 100%,\n    linear-gradient(to left, white 0.5px, transparent 1px) 100% 0,\n    linear-gradient(to left, white 0.5px, transparent 1px) 100% 100%,\n    linear-gradient(to bottom, white 0.5px, transparent 1px) 0 0,\n    linear-gradient(to bottom, white 0.5px, transparent 1px) 100% 0,\n    linear-gradient(to top, white 0.5px, transparent 1px) 0 100%,\n    linear-gradient(to top, white 0.5px, transparent 1px) 100% 100%;\n    background-repeat: no-repeat;\n    background-size: 6px 6px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor:pointer;\n}\n.nextbtn{\n    right: 0;\n    \n}\n.backbtn{\n    right: 80px;\n}\n.backicon-border{\n    border:1px solid #4A19ED;\n    width: 85%;\n    height: 85%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    \n}\n.backicon-border:hover{\n    background-color: #4A19ED;\n}\n.backicon{\n    width: 10px;\n}\n.doMySwiper .swiper-slide img {\n    width: 75%;\n}\n.what-we-do-body .content-left {\n    font-family: \"Chakra Petch\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    text-transform: none;\n    color: #ffffff;\n}\n.what-we-do-body .left-area h1 {\n    font-size: 20px;\n    font-weight: 600;\n    color: #ffffff;\n    font-family: 'Chakra Petch';\n}\n.what-we-do-body .left-area .text-area {\n    background: #4a19ed;\n    padding: 40px 38px;\n    width: 540px;\n    height: 180px;\n}\n.what-we-do-body .content-left-border {\n    width: fit-content;\n    padding: 6px;\n    background: linear-gradient(to right, #4a19ed 0.5px, transparent 2px) 0 0,\n      linear-gradient(to right, #4a19ed 0.5px, transparent 2px) 0 100%,\n      linear-gradient(to left, #4a19ed 0.5px, transparent 2px) 100% 0,\n      linear-gradient(to left, #4a19ed 0.5px, transparent 2px) 100% 100%,\n      linear-gradient(to bottom, #4a19ed 0.5px, transparent 2px) 0 0,\n      linear-gradient(to bottom, #4a19ed 0.5px, transparent 2px) 100% 0,\n      linear-gradient(to top, #4a19ed 0.5px, transparent 2px) 0 100%,\n      linear-gradient(to top, #4a19ed 0.5px, transparent 2px) 100% 100%;\n    background-repeat: no-repeat;\n    background-size: 12px 12px;\n    /* ---- */\n    position: absolute;\n    top: 8%;\n    left: 38%;\n    transform: translate(40%, 185%);\n    z-index: 999999;\n}\n.what-we-do-body .left-area{\n    border: 1px solid #4a19ed;\n    width: fit-content;\n    height: max-content;\n    padding: 10px;\n}\n/* .slider-photo {\n    width: 300px !important;\n}  */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
